import { QueryFunctionContext, useInfiniteQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetTeamTaskItemsDto, queryKeys, UrlUtilities, useAccessToken, type QueryParams } from "src/http";

const useGetTeamTaskItemSubtasksRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getTeamTaskItemSubtasksRequest({
    queryKey,
    pageParam: taskItemGuid,
  }: QueryFunctionContext<
    ReturnType<typeof queryKeys.taskItems.getTeamTaskItemSubtasks>
  >): Promise<GetTeamTaskItemsDto> {
    const accessToken = await getAccessToken();
    const [, teamSlug, queryParams] = queryKey;

    if (taskItemGuid === undefined) {
      return {
        taskItems: [],
      };
    }

    const url = new URL(`${configuration.apiRootUrl}/teams/${teamSlug}/task-items?parentTaskItemGuid=${taskItemGuid}`);
    UrlUtilities.appendQueryParams(url, queryParams);

    const response = await fetch(url.href, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getTeamTaskItemSubtasksRequest };
};

const useGetTeamTaskItemSubtasks = (teamSlug: string | undefined, queryParams?: QueryParams) => {
  const { getTeamTaskItemSubtasksRequest } = useGetTeamTaskItemSubtasksRequest();

  return useInfiniteQuery({
    queryKey: queryKeys.taskItems.getTeamTaskItemSubtasks(teamSlug, queryParams),
    queryFn: getTeamTaskItemSubtasksRequest,
    enabled: teamSlug !== undefined,
  });
};

export { useGetTeamTaskItemSubtasks };
